const pendingPhoneConfirmationKey: string = 'pendingPhoneConfirmation';

export const markPhoneConfirmationRequired = () => {
  sessionStorage.setItem(pendingPhoneConfirmationKey, 'true');
};

export const isPhoneConfirmationRequired = () => {
  return sessionStorage.getItem(pendingPhoneConfirmationKey) === 'true';
};

export const clearPhoneConfirmationRequired = () => {
  sessionStorage.removeItem(pendingPhoneConfirmationKey);
};
